
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flyer",
      function () {
        return require("private-next-pages/flyer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flyer"])
      });
    }
  